export default "__VITE_ASSET__5fbc1aae__"